import { DEVICE_TYPE, EXTERNAL_APPLY_CHANNEL } from '@/constants/common'
import {
  deviceDetector,
  getOmegaApplySource,
  getExternalChannel,
  getBrowserType,
  getBrowserVersion,
  getBrowserLanguage,
  getNetworkType,
} from '../common'
import { querySet } from '../url'
const Omega = window.Omega

const device = deviceDetector() ? DEVICE_TYPE.MOBILE : DEVICE_TYPE.PC // 设备类型

const getClickId = (): string => {
  const clickIdKeys = ['gclid', 'ttclid', 'fbclid', 'gbraid', 'wbraid']
  for (const key of clickIdKeys) {
    const value = querySet[key]
    if (value) return value
  }
  return ''
}

export const ENV = {
  os: (() => {
    try {
      return Omega.selfReport.context.osType.toLowerCase()
    } catch (e) {
      return 'android'
    }
  })(),
  version: (() => {
    try {
      return Omega.selfReport.context.osVersion
    } catch (e) {
      return 'unknown'
    }
  })(),
}

const addPublicParamsToOmega = () => {
  const attrs = {
    country: 'MX',
    country_code: 'MX',
    page_source: querySet.page_source,
    activity_id: querySet.activity_id,
    channel_id: querySet.channel_id,
    resource_id: querySet.resource_id,
    ext: querySet.ext,
    pub_biz_line: 'fin',
    os: ENV.os,
    operating_system: ENV.os,
    version: ENV.version,
    app_version: ENV.version,
    from_source: querySet.from_source,
    apply_source: getOmegaApplySource(),
    device_type: device,
    apply_channel: EXTERNAL_APPLY_CHANNEL,
    is_preload: querySet.fromIframe,
    marketing_source:querySet.fromPage || '',
    external_channel:getExternalChannel(),
    browser_type: getBrowserType(),
    browser_version: getBrowserVersion(),
    language: getBrowserLanguage(),
    network_type: getNetworkType(),
    page_version: '2026V1',
    from_page_id: querySet.fromPageId,
    app_id: querySet.app_id || '',
    click_id: getClickId(),
  }
  Omega.setConfig({
    attrs,
  })
}

addPublicParamsToOmega()

if (window.adv) {
  const { getMediaData, isAdvChannel, getAdvUUID } = window.adv
  const marketPublicParams = isAdvChannel() ? getMediaData() : {} // 外投埋点渠道公参
  Omega?.setConfig({
    attrs: {
      ...marketPublicParams,
      outcast_uuid: getAdvUUID() // 无论是不是营销渠道，都要上报
    }
  })
}

export const trackEvent = (eventId: string, attrs?: Record<string, any>) => {
  Omega?.trackEvent(eventId, '', attrs || {})
}

export const setConfig = (config: { page_id?: string }) => {
  Omega?.setConfig(config)
}

export const setPageId = (pageId?: string) => {
  if (!pageId || !String(pageId).trim()) return
  const normalizedPageId = String(pageId).trim()
  Omega?.setConfig({
    attrs: {
      page_id: normalizedPageId,
    },
  })
}

const omega = {
  trackEvent,
  setConfig,
  setPageId,
}

export default omega
